<button type="button" class="btn btn-sm btn-outline-danger reset-filter-btn" (click)="resetFilterData()">
    Reset Filters
</button>
